import * as z from "zod/v4";

export const getShippingErrorRateByCarrier = {
  name: "getShippingErrorRateByCarrier" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    carriers: z.array(z.object({ carrier: z.string(), errorRate: z.number() })),
  }),
};
